/**
 * @deprecated Use storage utilities from `@/core/auth/storage` instead.
 *
 * These functions are kept for backwards compatibility.
 * The storage module provides the same functionality with additional features
 * like getPortalAuth/setPortalAuth/clearPortalAuth for complete operations.
 */

const TOKEN_NAMESPACE = 'touchpoint_portal';

export const getPortalTokenKey = (clientId: string): string =>
  `${TOKEN_NAMESPACE}_token_${clientId}`;

export const getPortalRoleKey = (clientId: string): string =>
  `${TOKEN_NAMESPACE}_role_${clientId}`;

export const getPortalClientNameKey = (clientId: string): string =>
  `${TOKEN_NAMESPACE}_client_name_${clientId}`;
